import {
  type ReadonlyFieldProps,
  type FormNumberInputProps,
  FormNumberInput,
  ReadonlyField,
} from '@shared/components';
import { type FieldValues } from 'react-hook-form';

import { type BaseViewModeProps, type BaseInputModeProps } from '../../types';

type InputModeProps = BaseInputModeProps<Omit<FormNumberInputProps<FieldValues>, 'name'>>;

type ViewModeProps = BaseViewModeProps<Omit<ReadonlyFieldProps, 'content' | 'maxLines'>>;

export type NumberInputRendererProps = InputModeProps | ViewModeProps;

export default function NumberInputRenderer(props: Readonly<NumberInputRendererProps>) {
  switch (props.mode) {
    case 'input': {
      const { name, slotProps } = props;
      return <FormNumberInput name={name} {...slotProps} />;
    }
    case 'view': {
      const { value, slotProps } = props;
      return <ReadonlyField content={value} {...slotProps} />;
    }
  }
}
